/**
 * Purchase Manager Configuration Model
 * Stores user preferences for purchase manager features including Auto-Fill Smart Cart
 */

/**
 * UI state for each supplier row in the drag-drop list
 */
export interface SupplierPreferenceItem {
    id: string;         // Unique supplier identifier: 'hyperpure', 'udaan', 'dmart', 'local'
    name: string;       // Display name: 'Hyperpure', 'Udaan', 'D-Mart', 'Local Supplier'
    autoFill: boolean;  // Whether checkbox is checked (participates in auto-fill cart)
    position: number;   // Current sort order position (0-based)
}

/**
 * DB entry stored inside purchasemanagerConfig.supplierPreferrence array.
 * Array order = drag-sort order.
 * autoFill flag = checkbox state.
 */
export interface SupplierPreferenceEntry {
    name: string;       // 'hyperpure' | 'udaan' | 'dmart' | 'local'
    autoFill: boolean;  // true = checked (will auto-fill), false = unchecked
}

/**
 * Shape of purchasemanagerConfig stored in company table
 */
export interface PurchaseManagerConfig {
    // Array always contains all suppliers in drag-sort order.
    // autoFill=true means the supplier participates in auto-fill cart.
    supplierPreferrence?: SupplierPreferenceEntry[];
}

/**
 * All available suppliers — defines the default order and display names.
 * Matches the fixed set of 4 suppliers supported by the platform.
 */
export const DEFAULT_SUPPLIERS: SupplierPreferenceItem[] = [
    { id: 'hyperpure', name: 'Hyperpure', autoFill: true, position: 0 },
    { id: 'udaan', name: 'Udaan', autoFill: true, position: 1 },
    { id: 'dmart', name: 'D-Mart', autoFill: true, position: 2 },
    { id: 'local', name: 'Local Supplier', autoFill: true, position: 3 }
];

/**
 * Setup step enum for Auto-Fill Smart Cart wizard
 */
export enum AutoFillSetupStep {
    INTRO = 1,      // Step 1: How it works introduction
    CONFIGURE = 2   // Step 2: Select and sort suppliers
}
